import isString from 'lodash/isString';

import type { DataPoint } from 'shared/components/charts/BarChart/types';

export const isIntractable = (yLabel?: DataPoint['yLabel']) => isString(yLabel);
